import { render, staticRenderFns } from "./DialogPanSuscriptionAdmin.vue?vue&type=template&id=8163b29e"
import script from "./DialogPanSuscriptionAdmin.vue?vue&type=script&lang=js"
export * from "./DialogPanSuscriptionAdmin.vue?vue&type=script&lang=js"
import style0 from "./DialogPanSuscriptionAdmin.vue?vue&type=style&index=0&id=8163b29e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports